/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type Background_viewer$ref: FragmentReference;
export type Background_viewer = {|
  +mediaFiles: ?{|
    +mediaFiles: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +filename: ?string,
    |}>
  |},
  +$refType: Background_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Background_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "page",
      "type": "Int!",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "type",
      "type": "MediaFileTypeEnum",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "states",
      "type": "[MediaFileStateType]",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "mediaFiles",
      "name": "mediaFilesPaginate",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page",
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "pageSize",
          "value": 20,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "states",
          "variableName": "states",
          "type": "[MediaFileStateType]"
        },
        {
          "kind": "Variable",
          "name": "type",
          "variableName": "type",
          "type": "MediaFileTypeEnum"
        }
      ],
      "concreteType": "mediaFilesPaginate",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "mediaFiles",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaFile",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "id",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "filename",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1f80207647bdc091f3df59db218a63db';
module.exports = node;



// WEBPACK FOOTER //
// src/components/background/__generated__/Background_viewer.graphql.js